import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { DOORDASH_URL, UBEREATS_URL, PHONE_NUMBER } from '../data/menu';

export function FinalCTA() {
  const { t, isRTL } = useLanguage();

  return (
    <section 
      className="relative py-16 sm:py-32 overflow-hidden bg-[#6B1C23]"
      data-testid="final-cta-section"
    >
      {/* Background decorative circles — static */}
      <div className="absolute inset-0 hidden sm:block pointer-events-none">
        {[...Array(3)].map((_, i) => (
          <div
            key={`circle-${i}`}
            className="absolute rounded-full border border-white/10"
            style={{
              width: 300 + i * 200,
              height: 300 + i * 200,
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.15 - i * 0.03,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Headline */}
        <h2 
          className={`text-2xl sm:text-4xl lg:text-6xl font-semibold text-white mb-3 sm:mb-6 ${
            isRTL ? 'font-cairo' : 'font-cormorant'
          }`}
          data-testid="final-cta-title"
        >
          {t('cta.title')}
        </h2>
        
        {/* Subtitle */}
        <p 
          className={`text-sm sm:text-xl text-white/90 mb-6 sm:mb-12 ${isRTL ? 'font-cairo' : 'font-manrope'}`}
        >
          {t('cta.subtitle')}
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            asChild
            size="lg"
            className="w-full sm:w-auto bg-white text-[#6B1C23] hover:bg-gray-100 transition-all px-8 sm:px-10 py-5 sm:py-7 text-base sm:text-lg font-manrope font-semibold shadow-lg"
            data-testid="final-cta-doordash-btn"
          >
            <a href={DOORDASH_URL} target="_blank" rel="noopener noreferrer">
              {t('cta.orderNow')} — DoorDash
            </a>
          </Button>

          <Button
            asChild
            size="lg"
            className="w-full sm:w-auto bg-[#142328] text-white hover:bg-[#1f3640] transition-all px-8 sm:px-10 py-5 sm:py-7 text-base sm:text-lg font-manrope font-semibold shadow-lg"
            data-testid="final-cta-ubereats-btn"
          >
            <a href={UBEREATS_URL} target="_blank" rel="noopener noreferrer">
              {t('cta.orderNow')} — Uber Eats
            </a>
          </Button>
          
          <Button
            asChild
            size="lg"
            className="w-full sm:w-auto bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 border-2 border-white/80 transition-all px-8 sm:px-10 py-5 sm:py-7 text-base sm:text-lg font-manrope font-semibold"
            data-testid="final-cta-call-btn"
          >
            <a href={`tel:${PHONE_NUMBER}`} className="flex items-center justify-center gap-2">
              <Phone className="w-5 h-5" />
              {t('cta.callUs')}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
